module.exports = __webpack_public_path__ + "static/media/tallytap-logo-v1-transparent-230x65.a3122dab.JPG";